import * as uploadState from './upload-state';
import UploadType from './UploadType';

export * from './upload-state';
export { UploadType };
export default { UploadType, ...uploadState };
